import VueAuth from '@websanova/vue-auth'
import VueAuthAxios from '@websanova/vue-auth/drivers/http/axios.1.x.js'
import VueAuthRouter from '@websanova/vue-auth/drivers/router/vue-router.2.x.js'
import axios from 'axios'
import Vue from 'vue'
import VueAxios from 'vue-axios'
import router from './../router'
import auth from './auth'

Vue.router = router

Vue.use(VueAxios, axios)
Vue.use(VueAuth, {
    auth: auth,
    loginData: {
        url: 'token',
    },
    fetchData: {
        url: 'User/Me',
    },
    refreshData: {
        enabled: false,
    },
    parseUserData(data) {
        return data
    },
    http: VueAuthAxios,
    router: VueAuthRouter,
})
